<div class="btn-toolbar btn-max-content flex-nowrap justify-content-end" *transloco="let t; read: 'ime.components.help'">
  <ng-container *ngIf="isTopicSelected">
    <button type="button" class="btn btn-outline-primary btn-sm me-1" (click)="getUnmodifiedClick.emit()" *ngIf="helpService.hasBaseVersion">{{t('Get base version')}}</button>
    <button type="button" class="btn btn-outline-primary btn-sm me-1" (click)="saveClick.emit()" *ngIf="helpService.isEditMode">{{t('Save')}}</button>
    <button type="button" class="btn btn-outline-primary btn-sm me-1" [class.active]="helpService.isEditMode" (click)="editClick.emit()">
      <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
      {{t('Edit')}}
    </button>
  </ng-container>
</div>
